export const validateEmail = email => {
    if (email.length > 256) {
        return false;
    }

    const re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return re.test(String(email).toLowerCase());
}

export const validatePassword = password => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password);
}

export const validatePasswordWithMsg = password => {
    let msg = [];
    if (password.length < 8)
        msg.push('Minimum 8 Characters');
    if (password.length > 72)
        msg.push('Maximum 72 Characters');
    if (!/\d/.test(password))
        msg.push('At least one number');
    if (!/[a-zа-яіїє]/.test(password))
        msg.push('At least one lowercase letter');
    if (!/[A-ZА-ЯІЇЄ]/.test(password))
        msg.push('At least one uppercase letter');
    if (!/[!@#\$%\^\&*\)\(\]\[\{\}/,<>?\\|~'"+=._-]/.test(password))
        msg.push('At least one special character');
    if (!/^[\x00-\x7F]*$/.test(password))
        msg.push('No unsupported symbols');
    if (/\s/.test(password))
        msg.push('Spaces are not allowed');

    return msg;
}
